import React from 'react'
import '../assets/css/works.css'
import javaApi from '../assets/images/api.png'
import dash from '../assets/images/dashboardDd.png'
import mov from '../assets/images/Alphas-MoviesSC.png'
import show from '../assets/images/Showtime-Dashboard.png'
import station from '../assets/images/Rectangle 8.png'
import gozem from '../assets/images/gozem.png'

const Works = () => {
  return (
    <>
      <div className="mywork " id="work">
        <div className="mywork-title">
          <h2>Mes Récents Projets</h2>

          <h3>Mes Travaux</h3>
        </div>
        <div className="project-row">
          {/* Projet 1 */}
          <div className="project" data-aos="fade-up">
            <div className="project-img">
              <img
                src={javaApi}
                alt=""
                className="work-img"
              />
            </div>

            <div className="date-posted">
              <div className="who-post">
                <p className="admin">Java | SpringBoot | Edge Microservices</p>
              </div>
            </div>
            <div className="work-details">
              <h2>Elegancy Microservices API</h2>
              <p className="work-info">Application web basé sur l'architecture microservices | Application de gestion, Web Store</p>
              <div className="project-links">
                {/* <a
                  href="toggle"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-solid fa-laptop"></i>&nbsp;
                    View
                  </h6>
                </a> */}
                <a
                  href="https://github.com/Stilisky/Elegancy_Traditionnelle.git"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-brands fa-github"></i> &nbsp;
                    Code Source
                  </h6>
                </a>
              </div>
            </div>
          </div>
          {/* Projet 2 */}
          <div className="project" data-aos="fade-up">
            <div className="project-img">
              <img
                src={dash}
                alt=""
                className="work-img"
              />
            </div>

            <div className="date-posted">
              <div className="who-post">
                <p className="admin">ReactJS | NodeJS | MongoDB</p>
              </div>
            </div>
            <div className="work-details">
              <h2>Alphas Dashboard</h2>
              <p className="work-info">Application web qui fonctionne comme Netvibes.
              L'utilisateur se connecte d'abord à l'application et s'abonne ensuite à différents services accessibles.
              Chacun de ces services offrent différents widgets</p>
              <div className="project-links">
                {/* <a
                  href="toggle"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-solid fa-laptop"></i>&nbsp;
                    Voir
                  </h6>
                </a> */}
                <a
                  href="https://github.com/Stilisky/Alphas_Dashboard.git"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-brands fa-github"></i> &nbsp;
                    Code Source
                  </h6>
                </a>
              </div>
            </div>
          </div>
          {/* Projet 3 */}
          <div className="project" data-aos="fade-up">
            <div className="project-img">
              <img
                src={mov}
                alt=""
                className="work-img"
              />
            </div>

            <div className="date-posted">
              <div className="who-post">
                <p className="admin">NextJS | NodeJS | MongoDB | MoviesDB API</p>
              </div>
            </div>
            <div className="work-details">
              <h2>Alpha's Movies</h2>
              <p className="work-info">Le projet est un site de présentation et de critique de films en fonction des catégories. </p>
              <div className="project-links">
                {/* <a
                  href="toggle"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-solid fa-laptop"></i>&nbsp;
                    Voir
                  </h6>
                </a> */}
                <a
                  href="https://github.com/Stilisky/Alphas_Movies.git"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-brands fa-github"></i> &nbsp;
                    Code Source
                  </h6>
                </a>
              </div>
            </div>
          </div>

          {/* Projet 4 */}
          <div className="project" data-aos="fade-up">
            <div className="project-img">
              <img
                src={show}
                alt=""
                className="work-img"
              />
            </div>

            <div className="date-posted">
              <div className="who-post">
                <p className="admin">HTML/CSS | TailwindCSS | NestJS | MongoDB</p>
              </div>
            </div>
            <div className="work-details">
              <h2>My Show Times</h2>
              <p className="work-info">Le projet réalisé est un site web de réservation de billets.
              Les utilisateurs sélectionne les concerts auxquels ils souhaitent assister.</p>
              <div className="project-links">
                {/* <a
                  href="toggle"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-solid fa-laptop"></i>&nbsp;
                    Voir
                  </h6>
                </a> */}
                <a
                  href="https://github.com/Stilisky/GOZEM_BUSINNESS_CASE.git"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-brands fa-github"></i> &nbsp;
                    Code Source
                  </h6>
                </a>
              </div>
            </div>
          </div>

          {/* Projet 4 */}
          <div className="project" data-aos="fade-up">
            <div className="project-img">
              <img
                src={gozem}
                alt=""
                className="work-img"
              />
            </div>

            <div className="date-posted">
              <div className="who-post">
                <p className="admin">Angular | NodeJS | MongoDB</p>
              </div>
            </div>
            <div className="work-details">
              <h2>Web Driver Application</h2>
              <p className="work-info">Le projet réalisé est une plateforme d'enregistrement des colis et de suivi du trajet de la livraison d'un colis.</p>
              <div className="project-links">
                {/* <a
                  href="toggle"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-solid fa-laptop"></i>&nbsp;
                    Voir
                  </h6>
                </a> */}
                <a
                  href="https://github.com/Stilisky/My_Show_Time.git"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-brands fa-github"></i> &nbsp;
                    Code Source
                  </h6>
                </a>
              </div>
            </div>
          </div>

          {/* Projet 4 */}
          <div className="project" data-aos="fade-up">
            <div className="project-img">
              <img
                src={station}
                alt=""
                className="work-img"
              />
            </div>

            <div className="date-posted">
              <div className="who-post">
                <p className="admin">React Native | NodeJS </p>
              </div>
            </div>
            <div className="work-details">
              <h2>Gestion Station</h2>
              <p className="work-info">Le projet réalisé est une application mobile pour la gestion des stations à essence et des boutiques de vente.</p>
              <div className="project-links">
                {/* <a
                  href="toggle"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-solid fa-laptop"></i>&nbsp;
                    Voir
                  </h6>
                </a> */}
                {/* <a
                  href="https://github.com/Stilisky/My_Show_Time.git"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-brands fa-github"></i> &nbsp;
                    Code Source
                  </h6>
                </a> */}
              </div>
            </div>
          </div>

          {/* Projet 2 */}
          {/* <div className="project" data-aos="fade-up">
            <div className="project-img">
              <img
                src="javaApi"
                alt=""
                className="work-img"
              />
            </div>

            <div className="date-posted">
              <div className="who-post">
                <p className="admin">Java</p>
              </div>
            </div>
            <div className="work-details">
              <h2>Elegancy Microservices API</h2>
              <p className="work-info">desc</p>
              <div className="project-links">
                <a
                  href="toggle"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-solid fa-laptop"></i>&nbsp;
                    Voir
                  </h6>
                </a>
                <a
                  href="git"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <h6 className="learnmore">
                    <i class="fa-brands fa-github"></i> &nbsp;
                    Code Source
                  </h6>
                </a>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  )
}

export default Works